export const LS = {
    get:     (key, fallback = null) => { try { const v = localStorage.getItem(key); return v === null ? fallback : v; } catch { return fallback; } },
    set:     (key, val)             => { try { localStorage.setItem(key, String(val)); } catch {} },
    remove:  (key)                  => { try { localStorage.removeItem(key); } catch {} },
    getBool: (key, fallback = false)=> { const v = LS.get(key); return v === null ? fallback : v === 'true'; },
    getInt:  (key, fallback = 0)    => { const v = parseInt(LS.get(key)); return isNaN(v) ? fallback : v; },
    getFloat:(key, fallback = 0)    => { const v = parseFloat(LS.get(key)); return isNaN(v) ? fallback : v; },
};
